/**
 * @file Allow using app feature flags
 */
import { hasWwDebugUrlParam } from '@@/bits/dev_url_params'
import environment from '@@/bits/environment'
import window from '@@/bits/global'

type CurrentFlags =
  | 'accessControlSettingsV2'
  | 'accessControlSettingsV2RetroactiveUpdate'
  | 'addPostLink'
  | 'adminAnalyticsNuxtUi'
  | 'adminPostsAndCards'
  | 'affiliateSignupLink'
  | 'aiGrading'
  | 'aiImageSearch'
  | 'aiPermissionsForAiRecipes'
  | 'aiPermissionsForImageAndSpeechGeneration'
  | 'aiSuggestionsOnMakePage'
  | 'allSlideAsImageWithBanksy'
  | 'arLensesPreview'
  | 'attachmentPreviewWidthAdjustmentForGridFormat'
  | 'autoContentModeration'
  | 'banksy'
  | 'banksyDev'
  | 'billingAddress'
  | 'bulkEmailChangeForLibraries'
  | 'brahmsCheck'
  | 'campus'
  | 'changeEmailVerification'
  | 'classesV1'
  | 'classInformation'
  | 'classlinkSso'
  | 'classroomLicensesV2'
  | 'classroomPlanPricingExperiment'
  | 'cleverSso'
  | 'commandBar'
  | 'contentPickerCombinedAvRecorders'
  | 'commentAutoPublishOnUpload'
  | 'currentSlideAsImageWithBanksy'
  | 'customPostUserProperty'
  | 'customPostVoteAndRatingProperties'
  | 'dailyEmailDigestTeacher'
  | 'dashboardAnnouncement'
  | 'dashboardUpgradeCta'
  | 'dashHeaderCtaButton'
  | 'debugFrontend'
  | 'defaultDashboardLibraryNavigation'
  | 'demoPadletPanel'
  | 'demoPadletSignup'
  | 'deprecateArsPlans'
  | 'deprecateDrivePage'
  | 'deprecateGoldPlans'
  | 'deviceUploads'
  | 'downloadWallAttachmentsV2'
  | 'editThumbnail'
  | 'editThumbnailForAudioVideoFiles'
  | 'embeddedPadletsOnExpandedPost'
  | 'exitTicket'
  | 'fasterDashSettings'
  | 'featuredSection'
  | 'fetchLinksWithWishes'
  | 'frontChat'
  | 'fullClientSurface'
  | 'galleryTemplates'
  | 'googleAppLicensing'
  | 'googleClassroom'
  | 'googleClassroomGrading'
  | 'googleWorkspaceRostering'
  | 'grading'
  | 'groupPostsV2'
  | 'higherMonthlyPricingPlans'
  | 'internalNavigateImmediately'
  | 'joypixels8p0'
  | 'latamSpanishLanguage'
  | 'libraryGoogleAppLicensing'
  | 'librarySamlLogin'
  | 'librarySettingsConnectionsTab'
  | 'lmsUserGroupSync'
  | 'loadWishesViaSortBy'
  | 'lottieWebWorker'
  | 'ltiDeepLinkingMenuV2'
  | 'magicPadlet'
  | 'makePageSimplifiedLayoutExperiment'
  | 'maoriLanguage'
  | 'microsoftOneDrivePicker'
  | 'microsoftTeams'
  | 'mobileDeviceDprOverride'
  | 'notifyFailedPayments'
  | 'onboardingDemoV2'
  | 'onboardingDemoV2Copy'
  | 'onboardingGridLayout'
  | 'onboardingPanel'
  | 'openInAppBanner'
  | 'padletAnalytics'
  | 'pdndSurfaceGrid'
  | 'pdndSurfaceMap'
  | 'pdndSurfaceMatrix'
  | 'personalPricingPlansExperiment'
  | 'personalPricingPlansExperimentV2'
  | 'piChatV2'
  | 'piInputV2'
  | 'piSandboxChat'
  | 'piSubmissionFormWidget'
  | 'piUndo'
  | 'platinumResellerSelfServe'
  | 'playVideoInExpanded'
  | 'postComposerAttachmentPickerV2'
  | 'posthog'
  | 'pptxImport'
  | 'prefetchSurface'
  | 'publicApi'
  | 'pwaInstallButton'
  | 'reactionsToCustomPropertiesMigration'
  | 'realtimeFetching'
  | 'remakeLink'
  | 'remakeSettingV2'
  | 'removeArchive'
  | 'rostering'
  | 'routeToEurope'
  | 'samlIdp'
  | 'samlSetup'
  | 'sandboxAi'
  | 'sandboxCode'
  | 'whiteboardPermissionsV2'
  | 'sandboxPngFramePreview'
  | 'sandboxRetainActiveTool'
  | 'sandboxTextFormatting'
  | 'sandboxThemeBackgrounds'
  | 'schoolLibraryFreeze'
  | 'schoolLibraryPermissions'
  | 'schoolLibrarySSO'
  | 'schoolSelectionForTeachers'
  | 'scrollSmoothnessTracking'
  | 'selfServeFreeTrial'
  | 'shareShortcuts'
  | 'showAnonymousUserNames'
  | 'showCommandPalette'
  | 'showInvitedLibraryUsers'
  | 'sidePanelsV2'
  | 'signUpSurface'
  | 'slideshowRemote'
  | 'smartSuggestionsExperiment'
  | 'stripeBillingTax'
  | 'suggestedTemplates'
  | 'surfaceAiChat'
  | 'surfaceAiChatSchools'
  | 'surfaceAiChatSchoolsPermission'
  | 'surfaceCommentsPerPost'
  | 'surfaceCommentVideoPlayer'
  | 'surfaceConnectionsChange'
  | 'surfacePostVideoPlayer'
  | 'surfaceLibraryOrgVisitorPermissions'
  | 'surfaceMapsV2'
  | 'surfaceRoleBadges'
  | 'taxIdOnCheckout'
  | 'threeDAttachment'
  | 'templatesWithNewSidebar'
  | 'transferPadletTool'
  | 'transferPostWithCustomProperties'
  | 'transferSchoolPadletPermission'
  | 'translatePadlet'
  | 'translatePadletV2'
  | 'translationReporter'
  | 'turnstileOnSignup'
  | 'undoRedoDeleteSectionActions'
  | 'unicodeFontLoading'
  | 'unifiedSandboxColors'
  | 'unlimitedSandboxesV2'
  | 'upgradeModalCopyAExperiment'
  | 'upgradeModalSingleStepExperiment'
  | 'virtualFieldTrip'
  | 'virtualFieldTripNarration'
  | 'virtualizedDashboard'
  | 'virtualizedPostsGrid'
  | 'wallCardMaxWidth'
  | 'wallContentProtection'
  | 'wallEngagementTime'
  | 'wallEngagementTimeTracking'
  | 'weeklyEmailDigestTeacher'
  | 'whiteboardPreloadApis'
  | 'workspaceLoginRedirect'
  | 'yodishLanguage'
  | 'zapierIntegration'
  | 'nativeAccountSwitcher'
  | 'captionsTranslation'
  | 'arcadeAttachment'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const viteAppFlip =
    window.wwStartingState != null && typeof window.wwStartingState === 'function' ? window.wwStartingState().flip : {}
  const flip = ww.flip || ww.vueStartingState?.flip || viteAppFlip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

const isDebugMode =
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  hasWwDebugUrlParam()

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

// If on padlet.dev, use the local Banksy server to test PDF exports.
// Banksy and Banksy Dev on Cloud Run won't work because they cannot access a padlet.dev padlet.
// You will need to run the Banksy server first before you can test PDF exports.
// See: /services/banksy/README.md
const isAppUsingBanksyLocalDev = environment === 'development'

export type { CurrentFlags }
export { isAppUsing, isAppUsingBanksyLocalDev, isDebugMode }
